var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.218 6.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 64h24v24H20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -5.357 -17.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.253 64.256h7.745v23.5h-7.745a3.01 3.01 0 0 1-3.005-3.005V67.253a3.005 3.005 0 0 1 3.005-2.997m17.498 0h-7.753v10.75h10.75v-7.753a3 3 0 0 0-2.997-2.997m-7.753 23.5h7.753a3.005 3.005 0 0 0 2.997-3.005v-7.745h-10.75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.96d9297337d8f0fdf3ca1cbe80361100.svg";
export { ForwardRef as ReactComponent };